module.exports = __webpack_public_path__ + "img/email.be2381bc.svg";